import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Interceptor de petición: añade token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de respuesta: detecta token inválido o expirado
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401) {
      // No redirigir si el 401 viene del propio intento de login/register:
      // esos formularios gestionan sus propios errores en el catch.
      const url = error.config?.url ?? "";
      const isAuthAttempt = url.includes("/login") || url.includes("/register");
      if (!isAuthAttempt) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }
    }

    // Si la suscripción expiró mid-session, redirigir a la pantalla de suscripción
    // en lugar de dejar al usuario con errores de API sin contexto.
    if (status === 403 && error.response?.data?.error === 'subscription_expired') {
      window.location.href = '/admin/subscribe';
    }

    if (status === 429) {
      // Rate limit alcanzado: propagar con mensaje legible sin redirigir
      const err429 = new Error("Demasiadas solicitudes. Por favor, espera un momento antes de intentarlo de nuevo.");
      err429.isRateLimit = true;
      err429.originalError = error;
      return Promise.reject(err429);
    }

    if (status === 422) {
      // Errores de validación: propagar con el mensaje del backend si existe
      const backendMessage = error.response?.data?.message || "Los datos enviados no son válidos.";
      const err422 = new Error(backendMessage);
      err422.isValidationError = true;
      err422.errors = error.response?.data?.errors ?? {};
      err422.response = error.response;
      err422.originalError = error;
      return Promise.reject(err422);
    }

    return Promise.reject(error);
  }
);

export default api;